import { observer } from 'mobx-react-lite'

import Stack from '@mui/material/Stack'

import { H2, P } from '@mxenabled/mxui'

import { useGlobalCopyStore, useFinstrongStore } from '../../../common'

import { getSpendingFeeCountState } from '../../util/finstrongUtils'

import StatusChip from '../StatusChip'

const PayBillsOnTimeStickyComponent = () => {
  const { healthScore } = useFinstrongStore()
  const { finstrong: copyContent } = useGlobalCopyStore()

  const { key_indicators_spend: spendCopy } = copyContent
  const { pay_bills_on_time_drawer: copy } = spendCopy

  const state = getSpendingFeeCountState(healthScore.spending_fee_transaction_count)

  return (
    <Stack
      sx={{
        p: 24,
        backgroundColor: 'background.paper',
        borderBottom: '1px solid',
        borderColor: 'divider',
      }}
    >
      <P variant="body2">{copy.pay_bills_on_time_sticky_description}</P>
      <Stack direction="row" sx={{ alignItems: 'center', justifyContent: 'space-between' }}>
        <H2>
          {healthScore.spending_fee_transaction_count} {copy.pay_bills_on_time_sticky_fee_count}
        </H2>
        <StatusChip status={state} />
      </Stack>
    </Stack>
  )
}
export default observer(PayBillsOnTimeStickyComponent)
